import jwtDecode from "jwt-decode";
import config from "../config.js";
import http from "./httpService";
// import { logOut } from './redirect'

export async function addFirebaseToken(firebaseToken) {
   let rToken = localStorage.getItem("refresh_token");
   if (rToken && firebaseToken) {
      await http.post(`${config.apiUrl}/Account/FirebaseToken`, {
         FirebaseToken: firebaseToken,
         RefreshToken: rToken,
      });
      localStorage.setItem("listenerId", firebaseToken);
   }
}

export async function deleteFirebaseToken() {
   let rToken = localStorage.getItem("refresh_token");
   if (rToken) {
      await http.delete(`${config.apiUrl}/Account/FirebaseToken?refreshToken=` + rToken);
      localStorage.removeItem("listenerId");
   }
}

export function getCurrentUserId() {
   let token = localStorage.getItem("access_token");
   if (!token) {
      // logOut()
      return null;
   }
   const user = jwtDecode(token);
   return user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
}

export function getCurrentUserWorkHouseId() {
   let token = localStorage.getItem("access_token");
   if (!token) {
      // logOut()
      return null;
   }
   const user = jwtDecode(token);
   return Number(user?.WorkhouseId ?? 1);
}

export function getCurrentUserRole() {
   let token = localStorage.getItem("access_token");
   if (!token) {
      // logOut()
      return null;
   }
   const user = jwtDecode(token);
   return user["Role"];
}

export function sendUserInfo(user) {
   return http.post(`${config.apiUrl}/Account/Login`, user);
}

export function getCurrentUserName() {
   let token = localStorage.getItem("access_token");
   if (!token) {
      return null;
   }
   const user = jwtDecode(token);
   return user["Name"];
}
export function getCurrentDisplayName() {
   let token = localStorage.getItem("access_token");
   if (!token) {
      return null;
   }

   const user = jwtDecode(token);
   return user["DisplayName"];
}

export function hasPermission(permissionName) {
   let token = localStorage.getItem("access_token");
   if (!token) {
      return null;
   }

   const user = jwtDecode(token);
   const result = user.AccessPages.some((x) => x === permissionName);
   return result;
}

export const getTokenObject = () => {
   let accessToken = localStorage.getItem("access_token");
   if (accessToken) {
      let token = jwtDecode(accessToken);
      if (token) {
         return token;
      }
   }
   return null;
};
